import Amplify from 'aws-amplify';
import {RootState} from "@/store/index";

const Auth = {
    identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
    region: process.env.VUE_APP_REGION,
    userPoolId: process.env.VUE_APP_USER_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID,
    oauth: {
        // Domain name
        domain : process.env.VUE_APP_OAUTH_DOMAIN,

        // Authorized scopes
        scope : [ 'phone', 'email', 'profile', 'openid','aws.cognito.signin.user.admin' ],

        // Callback URL
        redirectSignIn : location.origin,

        // Sign out URL
        redirectSignOut : `${location.origin}/signout`,

        // 'code' for Authorization code grant,
        // 'token' for Implicit grant
        responseType: 'code',

        // optional, for Cognito hosted ui specified options
        options: {
            // Indicates if the data collection is enabled to support Cognito advanced security features. By default, this flag is set to true.
            AdvancedSecurityDataCollectionFlag : false
        }
    },

};

const Storage = {
    bucket: process.env.VUE_APP_S3_BUCKET,
    region: process.env.VUE_APP_REGION
};

Amplify.configure({
    Auth, Storage,
});

const {
    domain,
    redirectSignIn,
    redirectSignOut,
    responseType
} = Auth.oauth;

// Client ID
const clientId = Auth.userPoolWebClientId;

// The url of the Cognito Hosted UI
const url = `https://${domain}/login?redirect_uri=${encodeURIComponent(redirectSignIn)}&response_type=${responseType}&client_id=${clientId}`;

const state: RootState = {
    loginUrl: url,
    logged: false,
    user: null,
    credentials: null,
    files: [],
    nodesStack: []
};

export default state;
